module.exports = __webpack_public_path__ + "static/media/back.60810a52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/bottombar/back.svg
// module id = ./src/statics/bottombar/back.svg
// module chunks = 0